module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/article-3-96135f3885c630528a96e301cd702951.jpg";